import { IconChevronDownSmallOutline, IconChevronUpSmallOutline } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { CSSProperties } from 'react';

import { Column } from './DataGrid';
import DataGridRow from './DataGridRow';
import * as styles from './styles.css';
import IconButton from '../../../../../Components/UI/IconButton';
import { ProjectGroup, ProjectLine } from '../../../../../Types/project';

type Props = {
  columns: Column[];
} & (
  | {
      group: ProjectGroup;
      lines?: undefined;
      collapsed: boolean;
      onToggle: (group: ProjectGroup) => void;
    }
  | {
      group?: undefined;
      lines: ProjectLine[];
      collapsed?: undefined;
      onToggle?: undefined;
    }
);

const DataGridGroup = ({ group, lines, columns, collapsed, onToggle }: Props) => {
  const groupLines = lines || group.lines;

  const style = group ? ({ '--group-color': group.color } as CSSProperties) : undefined;

  const handleToggle = () => onToggle!(group!);

  return (
    <div className={styles['data-grid-group']} style={style}>
      {group && (
        <div
          className={styles['data-grid-group-row']}
          style={{ gridTemplateColumns: `6px minmax(360px, 1fr) repeat(${columns.length - 1}, 156px)` }}
        >
          {columns.map((column, i) => (
            <div
              key={column.id}
              className={cx(styles['data-grid-column'], {
                [styles['data-grid-column--end']]: column.align === 'end',
              })}
            >
              {i === 0 && (
                <IconButton
                  icon={collapsed ? <IconChevronUpSmallOutline /> : <IconChevronDownSmallOutline />}
                  onClick={handleToggle}
                  title={translate('actions.close')}
                  marginRight={2}
                />
              )}
              {column.group(group)}
            </div>
          ))}
        </div>
      )}

      {!collapsed && groupLines.map((line) => <DataGridRow key={line.id} line={line} columns={columns} />)}
    </div>
  );
};

export default DataGridGroup;
